module.exports = __webpack_public_path__ + "img/lbl-01.dd622064.png";